import { fieldPath } from './form-errors';

/** Focus remains scoped to the owning form (including forms inside a modal). */
export function focusFormField(form: HTMLFormElement | null, path: string): boolean {
  if (!form) return false;
  const field = fieldPath(path);
  const elements = [...form.querySelectorAll<HTMLElement>('[name], [data-field]')];
  const exact = elements.find(
    (element) => element.getAttribute('name') === field || element.dataset.field === field,
  );
  const group = elements.find(
    (element) => element.dataset.field && field.startsWith(element.dataset.field + '.'),
  );
  const suffixes = elements.filter((element) => {
    const name = element.getAttribute('name') ?? element.dataset.field;
    return name && field.endsWith('.' + name);
  });
  const target = exact ?? (suffixes.length === 1 ? suffixes[0] : undefined) ?? group;
  const input = target?.matches('input:not([type="hidden"]), select, textarea, button')
    ? target
    : target?.querySelector<HTMLElement>(
        'input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), button:not(:disabled), [tabindex="0"]',
      );
  if (!input || input.matches(':disabled')) return false;
  input.focus({ preventScroll: true });
  input.scrollIntoView?.({ block: 'center', behavior: 'auto' });
  return true;
}
